export const InputLabel = ({ label, name, className = '' }) => {
	if(label) {
		return (
			<label className={`inputwrap-label ${className}`} htmlFor={name}>
				{label}
			</label>
		)
	}
	else {
		return null;
	}
}